// validate date in format BR (dd/mm/yyyy)
export const dateValidator = (value: unknown) => {
  if (typeof value !== 'string') {
    return false;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [day, month, year] = value.split('/').map(Number);

    if (day < 1 || day > 31) {
      return false;
    }

    if (month < 1 || month > 12) {
      return false;
    }

    if (year < 1900 || year > 2100) {
      return false;
    }

    const generatedDate = new Date(year, month - 1, day);
    const [generatedDay, generatedMonth, generatedYear] = [
      generatedDate.getDate(),
      generatedDate.getMonth() + 1,
      generatedDate.getFullYear(),
    ];

    if (generatedDay !== day || generatedMonth !== month || generatedYear !== year) {
      return false;
    }

    return true;
  }

  return false;
};

export const datePastValidator = (value: unknown) => {
  if (!dateValidator(value)) {
    return false;
  }

  const [day, month, year] = (value as string).split('/').map(Number);
  const date = new Date(year, month - 1, day);

  return date < new Date();
};
